import React, { useEffect, useState } from 'react';
import { clampNumber } from './unitEconomicsLogic';

const UnitEconomicsNumberField = ({ label, hint, unit, value, onChange, min, max, step = 1 }) => {
  const [draft, setDraft] = useState(String(value));
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDraft(String(value));
    }
  }, [value, isFocused]);

  const handleChange = (event) => {
    const raw = event.target.value;

    if (raw === '') {
      setDraft('');
      return;
    }

    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) {
      return;
    }

    setDraft(raw);
    onChange(clampNumber(parsed, min, max));
  };

  const handleFocus = (event) => {
    setIsFocused(true);
    setDraft(String(value));
    event.target.select();
  };

  const handleBlur = () => {
    setIsFocused(false);

    if (draft === '') {
      onChange(min);
      setDraft(String(min));
      return;
    }

    const parsed = clampNumber(draft, min, max);
    onChange(parsed);
    setDraft(String(parsed));
  };

  return (
    <div className="ue-field">
      <div className="ue-field-label">
        <span>{label}</span>
        {hint ? <span className="ue-field-hint-inline">{hint}</span> : null}
        {unit ? <span className="ue-field-hint-inline">{unit}</span> : null}
      </div>
      <div className="ue-input-wrap">
        <input
          type="number"
          className="ue-input"
          min={min}
          max={max}
          step={step}
          value={isFocused ? draft : value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        {unit ? <span className="ue-input-unit">{unit}</span> : null}
      </div>
    </div>
  );
};

export default UnitEconomicsNumberField;
